import React from "react";

export const formatDateCustom = (
    value: Date | string | number,
    locale = "es-MX"
): string => {
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");

    // Obtener mes corto en texto
    const month = new Intl.DateTimeFormat(locale, { month: "short" })
        .format(date)
        .replace(".", ""); // eliminar punto si existe

    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const formatWithPattern = (
    value: Date | string | number,
    pattern: string
) => {
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";

    const map: Record<string, string> = {
        dd: String(date.getDate()).padStart(2, "0"),
        MM: String(date.getMonth() + 1).padStart(2, "0"),
        yyyy: String(date.getFullYear()),
        HH: String(date.getHours()).padStart(2, "0"),
        mm: String(date.getMinutes()).padStart(2, "0"),
    };

    return pattern.replace(/dd|MM|yyyy|HH|mm/g, (match) => map[match]);
};

const DateFormat = (props: any) => {

    const {
        locale = "es-MX",
        dateStyle = "medium",   // "full" | "long" | "medium" | "short"
        timeStyle,              // opcional: "full" | "long" | "medium" | "short"
        options = {},           // opciones avanzadas (sobrescriben dateStyle/timeStyle)
    } = props;

    const { value }: { value: Date | string | number } = props;


    if (!value) return <span>-</span>;

    const date = new Date(value);

    if (isNaN(date.getTime())) return <span>-</span>;

    // const formatter = new Intl.DateTimeFormat(locale, {
    //     ...(dateStyle && { dateStyle }),
    //     ...(timeStyle && { timeStyle }),
    //     ...options,
    // });

    return <span>{formatDateCustom(date)}</span>;
};

export default DateFormat;